import {
  AbstractControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';

import { PhoneNumberUtil } from 'google-libphonenumber';

export class PhoneNumberValidator {
  public static phoneNumber = 'phoneNumber';

  public static validate(countryCodeControl: AbstractControl): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      let e: any = {};
      const p = control.value;

      if (p && p.trim().length > 0) {
        const c = countryCodeControl ? countryCodeControl.value : '';

        try {
          const pu = PhoneNumberUtil.getInstance();
          const ph = pu.parse(p, c);
          if (pu.isValidNumber(ph) === true) {
            e = {};
          } else {
            e[PhoneNumberValidator.phoneNumber] = true;
          }
        } catch (ex) {
          e[PhoneNumberValidator.phoneNumber] = true;
        }
      }

      return e;
    };
  }

  public static validatePhoneNumber(countryCode: string, phoneNumber: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[phoneNumber];
      const countryCodeControl = formGroup.controls[countryCode];

      if (!control || !countryCodeControl) {
        return;
      }

      const p = control.value;

      if (p && p.trim().length > 0) {
        const c = countryCodeControl ? countryCodeControl.value : '';

        try {
          const pu = PhoneNumberUtil.getInstance();
          const ph = pu.parse(p, c);
          if (pu.isValidNumber(ph) === true) {
            control.setErrors(null);
          } else {
            control.setErrors({ [PhoneNumberValidator.phoneNumber]: true });
          }
        } catch (ex) {
          control.setErrors({ [PhoneNumberValidator.phoneNumber]: true });
        }
      }
    };
  }
}
